import { toggleGlobalAuthModal } from '@/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic.js';
import { RootState } from '@/redux/reducers';

const AuthModal = dynamic(() => import('@/components/DesignSystem/AuthPopUp'));

const GlobalAuthModal = () => {
  const dispatch = useDispatch();

  const { user, showGlobalAuthModal } = useSelector((state: RootState) => ({
    user: state.userReducer,
    showGlobalAuthModal: state.commonReducer?.globalAuthModal?.show,
  }));

  const toggleAuthModal = () => {
    if (!user?.isLogin) {
      dispatch(toggleGlobalAuthModal(false));
      return;
    }

    if (!showGlobalAuthModal) {
      return;
    }

    dispatch(toggleGlobalAuthModal(false));
  };

  if (!showGlobalAuthModal) {
    return null;
  }

  return <AuthModal toggleModal={toggleAuthModal} isVisible={showGlobalAuthModal} />;
};

export default GlobalAuthModal;
